module.exports = __webpack_public_path__ + "img/Iargo-Springs.be67f675.jpg";